export default __webpack_public_path__ + "static/media/mj_coverphoto.dc2d9cb1.jpeg";